import React, { useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from "react-router-dom";
import { login_sso, caught_sso, update_token } from "../auth/SSO";
import Navbar from "../parts/navbar/Navbar";
import SideBar from "../parts/sidebar/SideBar";
import { routes } from "./routes";
import { Helmet, HelmetProvider } from "react-helmet-async";

// SSO
import { dontCry } from "../auth/KiritoHelper";
import isEmpty from "lodash/isEmpty";
import axios from "axios";
import LandingPage from "../pages/landing-page/LandingPage";
import Bursa from "../pages/bursa/Bursa";
import SideBarNoAuth from "../parts/sidebar/SideBarNoAuth";
import NavbarNoAuth from "../parts/navbar/NavbarNoAuth";

import loadingSSO from "../assests/lottie/loadingSSO.json";
import Lottie from "react-lottie";

// SSO ENV
const sso = `${process.env.REACT_APP_SSO_URL}`;
const clientId = `${process.env.REACT_APP_CLIENT_ID}`;
const redirectUri = `${process.env.REACT_APP_SSO_REDIRECT_URI}`;
const api = `${process.env.REACT_APP_API}`;

const helmetContext = {};

const defaultOptions = {
  loop: true,
  autoplay: true,
  animationData: loadingSSO,
  rendererSettings: {
    preserveAspectRatio: "xMidYMid slice",
  },
};

axios.interceptors.response.use(
  (successRes) => {
    return successRes;
  },
  (error) => {
    console.log("error", error.config);
    return update_token(error);
  }
);
function LoadingRedirect(props) {
  return (
    <div
      className="flex justify-center items-center"
      style={{ minHeight: "100vh" }}
    >
      <Lottie options={defaultOptions} height={400} width={400} />
      {/* <p>{props.text}</p> */}
    </div>
  );
}

export default function MainRouter(props) {
  function auth_login_sso() {
    const urlParams = new URLSearchParams(window.location.search);
    const paramRedirect = urlParams.get("redirect");

    if (!isEmpty(paramRedirect))
      localStorage.setItem("redirect", paramRedirect);

    login_sso();
    return <LoadingRedirect type={1} text="Mengalihkan ke SSO" />;
  }

  function auth_redirect_sso() {
    const urlParams = new URLSearchParams(window.location.search);
    const paramCode = urlParams.get("code");

    axios.get(api + "/auth/sso/redirect?code=" + paramCode).then((res) => {
      if (res.data.status === "success") {
        localStorage.setItem(
          "authenticatedUser",
          JSON.stringify(res.data.data)
        );
        window.location.href = "/";
      }
    });

    if (paramCode == null) {
      return <Redirect to="/" />;
    }

    return <LoadingRedirect type={2} text="Kembali ke Schoolmedia Biz" />;
  }

  function auth_caught_sso() {
    // alert("Caught woy")
    let obj = caught_sso();
    if (!obj.hasOwnProperty("message")) {
      //pass data user to backend
      //reencrypt

      let data = dontCry(JSON.stringify(obj, "e"));

      axios
        .get(api + "/auth/sso/caught?SSO_TOKEN=" + data)
        .then((response) => {
          var res = response.data;

          if (response.data.redirect) {
            return <Redirect to={response.data.redirect} />;
          } else {
            //set jwtToken
            localStorage.setItem("authenticatedUser", JSON.stringify(res.data));
            // setredirect_status(true);
            window.location.href = "/";
          }
        })
        .catch((error) => {
          console.error("error", error);
        });
    } else {
      let url =
        sso + "/auth?client_id=" + clientId + "&redirect_uri=" + redirectUri;
      window.location.replace(url);
    }
    return <LoadingRedirect type={2} text="Cek status login kamu" />;
  }

  async function auth_logout_sso() {
    let data = JSON.parse(localStorage.getItem("authenticatedUser")) ?? false;
    if (data.token) {
      axios
        .get(api + "/auth/sso/logout?token=" + data.token)
        .then((res) => {
          localStorage.removeItem("authenticatedUser");
          window.location.href = "/";
        })
        .catch((err) => {
          window.location.href = "/";
        });
    }

    return <LoadingRedirect type={3} text="Lagi keluar :)" />;
  }

  function auth_callback_sso() {
    return <LoadingRedirect type={2} text="Callback SSO" />;
  }

  function testss() {
    return <div>tes bos</div>;
  }

  let token =
    JSON.parse(localStorage.getItem("authenticatedUser"))?.token ?? null;
  return (
    <HelmetProvider>
      <Router>
        <Switch>
          <Route exact path="/auth" render={auth_login_sso} />
          <Route exact path="/auth/sso/redirect" render={auth_redirect_sso} />
          <Route exact path="/auth/sso/caught" render={auth_caught_sso} />
          <Route exact path="/auth/sso/logout" render={auth_logout_sso} />
          <Route exact path="/auth/sso/callback" render={auth_callback_sso} />
          <Route exact path="/tes" render={testss} />

          {!!!token ? (
            <Route exact path="/">
              <NavbarNoAuth />
              <div
                className="flex flex-row pt-12 bg-white dark:bg-gray-900"
                style={{ minWidth: "1280px" }}
              >
                <div className="w-2/12">
                  <SideBarNoAuth />
                </div>
                <div className="w-10/12">
                  <Helmet context={helmetContext}>
                    <title>Kuesioner</title>
                  </Helmet>
                  <Bursa />
                  {/* <LoadingRedirect type={2} text="Callback SSO" /> */}
                </div>
              </div>
            </Route>
          ) : (
            routes.map((val, idx) => {
              return (
                <Route key={idx} exact={val.exact ?? false} path={val.path}>
                  <Navbar />
                  <div
                    className="flex flex-row pt-12 bg-white dark:bg-gray-900"
                    style={{ minWidth: "1280px" }}
                  >
                    <div className="w-2/12">
                      <SideBar />
                    </div>
                    <div className="w-10/12">
                      <Helmet context={helmetContext}>
                        <title>{val.title}</title>
                      </Helmet>
                      <val.component />
                    </div>
                  </div>
                </Route>
              );
            })
          )}
        </Switch>
      </Router>
    </HelmetProvider>
  );
}
